import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "relative rounded-md bg-white py-1.5 pr-1.5 pl-3 shadow-sm ring-1 ring-inset ring-gray-300 w-full group/filter-box" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "font-normal mb-1" }
const _hoisted_4 = { class: "text-sm flex items-center" }
const _hoisted_5 = { class: "mr-3 text-gray-400" }
const _hoisted_6 = { class: "relative w-full" }
const _hoisted_7 = {
  key: 0,
  class: "text-gray-500 max-w-[160px] overflow-hidden whitespace-nowrap text-ellipsis mr-1"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "block truncate font-normal" }

import { Listbox, ListboxButton, ListboxOptions, ListboxOption } from "@headlessui/vue";
import { useCurrentCustomerName, useCurrentSiteId } from "@oculai/planner";
import { ref, PropType, onMounted } from "vue";
import { watch } from "vue";
import { useI18n } from "vue-i18n";
import UnitValueRepository from "@/repositories/UnitValueRepository";
import { ReportUnitValueTypeFilter } from "@/types/Report";


export default /*#__PURE__*/_defineComponent({
  __name: 'UnitValueTypeFilter',
  props: {
  selected: {
    type: String as PropType<ReportUnitValueTypeFilter["value"]>,
    default: "",
  },
},
  emits: ["refetch"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const { t } = useI18n();
const emits = __emit;
const customerName = useCurrentCustomerName();
const siteId = useCurrentSiteId();

const unitValueType = ref(props.selected);
const unitValueTypeOptions = ref<{ name: string; value: string }[]>([]);

onMounted(async () => {
  const types = await UnitValueRepository.loadUnitValuesTypes(customerName, siteId);

  const typeOptions = types.map((type) => ({
    value: type,
    name: `${t(`unit_values.types.${type}.label`)} [${t(`unit_values.types.${type}.unit`)}]`,
  }));

  unitValueTypeOptions.value = typeOptions;
});

watch(
  () => props.selected,
  (value) => {
    unitValueType.value = value;
  },
);

const handleFilterChange = (value: string) => {
  unitValueType.value = value;
  emits("refetch");
};

const getFilters = () => {
  const payload = {
    type: "unit_value_type",
    value: unitValueType.value,
  };

  return payload;
};

__expose({
  getFilters,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("analytics.reports.unit_value")), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)("analytics.reports.is")), 1),
      _createVNode(_unref(Listbox), {
        as: "div",
        style: {"min-width":"180px"},
        modelValue: unitValueType.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((unitValueType).value = $event)),
        class: "flex-1"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_unref(ListboxButton), {
              class: _normalizeClass([
              'flex py-0.5 px-4 border rounded-full max-w-60 cursor-pointer w-full truncate',
              unitValueType.value ? 'border-gray-300' : 'border-yellow-400',
            ])
            }, {
              default: _withCtx(() => [
                (unitValueType.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_unref(t)(`unit_values.types.${unitValueType.value}.label`)), 1))
                  : (_openBlock(), _createElementBlock("p", _hoisted_8, "..." + _toDisplayString(_unref(t)("unit_values.select_type")), 1))
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(_Transition, {
              "leave-active-class": "transition ease-in duration-100",
              "leave-from-class": "opacity-100",
              "leave-to-class": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(ListboxOptions), { class: "absolute z-50 mt-1 max-h-60 overflow-auto rounded-md bg-white py-1 text-xs shadow-lg ring-1 ring-yellow-500/5 focus:outline-none sm:text-sm w-full" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unitValueTypeOptions.value, (option) => {
                      return (_openBlock(), _createBlock(_unref(ListboxOption), {
                        as: "template",
                        key: option.value,
                        value: option.value
                      }, {
                        default: _withCtx(({ active, selected }) => [
                          _createElementVNode("li", {
                            class: _normalizeClass([
                    (active || selected) && 'bg-yellow-100',
                    'relative cursor-pointer select-none py-2 pl-3 pr-9 text-gray-900',
                  ]),
                            onClick: ($event: any) => (handleFilterChange(option.value))
                          }, [
                            _createElementVNode("span", _hoisted_10, _toDisplayString(option.name), 1)
                          ], 10, _hoisted_9)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})